Ext.define('SA.PowersOfThousand', {
    singleton: true,

    suffixes: ['', 'K', 'M', 'B', 'T'],

    getPower(value) {
        return Ext.Number.constrain(Math.trunc(Math.log(Math.abs(value)) / Math.log(1000)), 0, 4);
    },

    getSuffix(power) {
        return this.suffixes[power];
    },

    toFixed({value, power, decimals}) {
        var significand = this.toPower(value, power);

        return significand.toFixed(decimals) + this.getSuffix(power);
    },

    toPower(value, power) {
        return value / Math.pow(1000, power);
    }
});